import React, { useState, useEffect } from 'react';
import AresNavBar from '../../Layout/NavBar/NavBar';
import SideBar from '../../Layout/SideBar/SideBar';
import NoAvatar from '../../../assets/img/no-avatar.png'

import './index.css'
import { Col, Row, Spinner, Container } from 'react-bootstrap';

import axios from '../../../services/Api'
import EditUserForm from './EditUserForm';

function EditUser() {
    const [loading, setLoading] = useState(false)
    const [profile, setProfile] = useState([])
    const [plan, setPlan] = useState(null)
    const query = new URLSearchParams(window.location.search);
    const client_id = query.get('id');

    useEffect(() => {
        init();
        setLoading(true);
    }, []);

    function init() {
        getProfile();
    }
    
    async function getProfile() {
        try {
          const response = await axios.get(`/api/user/show/${client_id}`);
          setProfile(response.data);
          setLoading(false)
          return response.data;
        } catch (e) {
          console.log(e);
          setLoading(false)
        }
      }

    function renderLoading() {
        return (
            <div className="center-page">
                <Spinner animation="border" />
            </div>
        )
    }

    return (
        <div className="side-content">
            <AresNavBar />
            <SideBar />
            <div className="EditUser">
                <div className="bg-editUser">
                    <img src={NoAvatar} alt="Ares Logo" className="avatar" />
                </div>
                {loading ?
                    renderLoading()
                    :
                    <Container fluid>
                        <div className="desktop-form">
                            <EditUserForm data={profile} />
                        </div>
                        <div className="mobile-form">
                            <EditUserForm data={profile} />
                        </div>
                    </Container>
                }
            </div>
        </div>
    );
};

export default EditUser;